export const StrengthPicker = ({ variants, value, onChange, label }) => (
  <div className="flex flex-wrap gap-2" role="radiogroup" aria-label={label} data-testid="strength-picker">
    {variants.map((v) => {
      const selected = v.id === value;
      return (
        <button
          key={v.id}
          type="button"
          role="radio"
          aria-checked={selected}
          onClick={() => onChange(v.id)}
          data-testid={`strength-${v.strength}`}
          className={`rounded-full px-5 py-2.5 text-sm border transition-colors ${selected ? "bg-[#59394F] text-[#F4EBDD] border-[#59394F]" : "bg-white text-[#5A433B] border-[#A8B59A]/40 hover:border-[#C99898]"}`}
        >
          {v.strength}
        </button>
      );
    })}
  </div>
);

// One option: show it as text. Several: a picker under "Select Strength" / "Select Size".
export const ProductOptions = ({ variants, value, onChange, kind }) => (
  variants.length === 1 ? (
    <p className="text-sm text-[#5A433B]" data-testid="single-option">
      <span className="text-[10px] uppercase tracking-[0.2em] text-[#5E6B51] mr-2">{kind}:</span>{variants[0].strength}
    </p>
  ) : (
    <div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#5E6B51] mb-3" data-testid="option-label">Select {kind}</div>
      <StrengthPicker variants={variants} value={value} onChange={onChange} label={`Select ${kind}`} />
    </div>
  )
);
